import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as cloneDeep from 'lodash/cloneDeep';
import { BACKGROUNDIMAGE } from 'src/app/app.config';
import { Busca, Hotel, PacoteReserva, Paginacao } from 'src/app/model';
import { PacotelstService } from 'src/app/services/turismo/pacotelst.service';
import { Util } from 'src/app/services/index';

@Component({selector: 'app-pacote-hotel',
    templateUrl: './pacote-hotel.component.html',
    styleUrls: ['./pacote-hotel.component.scss'], standalone: false})
export class PacoteHotelComponent implements OnInit {

    constructor(
        // private hotelService: HotelService,
        private pacoteService: PacotelstService,
        public _router: Router,
        public route: ActivatedRoute,
        private modalService: NgbModal,
        private utilService: Util
    ) { }

    @Output() selecionou = new EventEmitter<any>();
    @Output() removeu = new EventEmitter<any>();
    @Output() avancar = new EventEmitter<any>();
    @Input() Orcamento: PacoteReserva[] = [];
    @Input() busca: Busca;
    totalValorListagemServico: number = 0;
    paginacao: Paginacao = new Paginacao();
    // busca: Busca = new Busca();
    objModal: any;
    hoteis: Hotel[] = [];
    carregando = true;
    pacoteReserva: any = new PacoteReserva();
    itemBusca: any = null;
    progress: any;
    pacoteId: any;
    qntTrechos = 0;
    usuario = null;
    buscando = false;
    rebusca = false;
    mensagemErro: '';
    objHotel: any;
    indice: number;
    PacoteDetalhes: any;
    backgroundimage = BACKGROUNDIMAGE;
    bannerTopImagemPacote: string = "";

    ngOnInit() {
        if (this.busca.PacoteId == 0){
            this.busca = this.busca.decodeBuscaEspecificaPacoteHome(window.sessionStorage.getItem("buscapacote"));
        }
        this.buscarHoteisPacote();
    }

    rotaAvancar() {
        this.avancar.emit('');
    }

    contemBanner: boolean = false;
    buscarHoteisPacote() {
        const buscaHotel = this.busca.getBuscaHotel();
        this.buscando = true;
        this.pacoteService
            .buscarEstatico(buscaHotel)
            .subscribe(
                dados => {
                    this.pacoteReserva = dados;
                    this.pacoteReserva.PacoteImagens = this.pacoteReserva.Pacote.PacoteImagens.map(x => {
                        x.Imagem = Util.pathImagemApi(x.Imagem);
                        return x;
                    })

                    this.bannerTopImagemPacote = this.pacoteReserva.PacoteImagens.find(x => x.Banner)?.Imagem ?? this.pacoteReserva.PacoteImagens[0]?.Imagem;
                    this.contemBanner = this.pacoteReserva.PacoteImagens.findIndex(x => x.Banner) > -1 ;

                    if (this.pacoteReserva?.Servicos != null && this.pacoteReserva.Servicos.length > 0) {
                        this.totalValorListagemServico = this.pacoteReserva.Servicos.reduce((total, servico) => total + servico.ValorListagem, 0);
                    }

                    this.pacoteReserva.Hoteis = this.pacoteReserva.Hoteis.map(x => {
                        x.Id = x.Id * -1;

                        const opcoes = x.Quartos.map(q => q.Pesquisa)
                            .filter(this.distinct)
                            .sort();
                        x.opcoes = [];
                        for (let i = 0; i < opcoes.length; i++) {
                            x.opcoes.push(x.Quartos.filter(x => x.Pesquisa == opcoes[i]));
                        }
                        x.Quartos = [];
                        x.melhorPreco = 0;
                        for (let i = 0; i < opcoes.length; i++) {
                            x.Quartos.push(x.opcoes[i][0]);
                            x.melhorPreco += x.opcoes[i][0].ValorListagem;
                        }
                        x.Soma = this.somaTotal(x.Quartos) + this.totalValorListagemServico;
                        return x;
                    });
                    this.pacoteReserva.Hoteis.sort((a, b) => a.Soma - b.Soma);
                    this.buscando = false;
                    window.sessionStorage.setItem('pacoteReserva', JSON.stringify(this.pacoteReserva));
                    window.sessionStorage.setItem("buscapacote", JSON.stringify(this.busca));
                },
                erro => {
                    this.buscando = false;
                    console.log(erro);
                    alert(this.utilService.fazerTraducao(this.utilService.errorHandler(erro, 'buscar hoteis')));
                    this._router.navigateByUrl("/listagem-pacotes/pacotes");
                }
            );
    }

    somaTotal(arr) {
        return arr
            .map(x => x.ValorListagem)
            .reduce(function (a, b) {
                return a + b;
            }, 0);
    }

    distinct = (value, index, self) => {
        return self.indexOf(value) === index;
    }

    hotelSelecionado(hotel) {
        const dado = this.Orcamento[0]?.Hoteis.filter(
            x => x.CodigoFornecedor === hotel.CodigoFornecedor
                && x.Fornecedor == hotel.Fornecedor
        );
        return dado?.length;
    }

    selecionarHotel(hotel) {
        hotel.selecionado = true;
        let pacotereservaClone = cloneDeep(this.pacoteReserva);
        pacotereservaClone.Hoteis = [];
        pacotereservaClone.Hoteis.push(hotel);
        if (this.Orcamento.length > 0) {
            this.Orcamento[0] = pacotereservaClone;
        } else {
            this.Orcamento.push(pacotereservaClone);
        }
        this.selecionou.emit(this.Orcamento);
        this.avancar.emit('');
    }

    removerHotel(hotel) {
        let indice = -1;
        for (let i = 0; i < this.Orcamento[0].Hoteis.length; i++) {
            if (this.Orcamento[0].Hoteis[i].Id == hotel.Id) {
                indice = i;
            }
        }
        if (indice >= 0) {
            this.Orcamento[0].Hoteis.splice(indice, 1);

            hotel.QuantidadeSelecionada = this.Orcamento[0].Hoteis.filter(x => x.CodigoFornecedor == hotel.CodigoFornecedor && x.Fornecedor == hotel.Fornecedor).length;

            if (hotel.QuantidadeSelecionada == 0) {
                hotel.selecionado = false;
            }

            this.removeu.emit(hotel);
        }
    }

    temHotel() {
        if (this.Orcamento[0]?.Hoteis.filter(x => x.selecionado == true).length > 0) {
            return true;
        } else {
            return false;
        }
    }

    atualizaHotel(hotel) {
        console.log(hotel);
    }

    buscarPagina(pagina) {
        this.paginacao.NumeroPagina = pagina;
        this.buscarHoteisPacote();
    }

    abrirModal(content, hotel) {
        this.PacoteDetalhes = hotel;
        this.objHotel = hotel;
        this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true, size: 'lg' });
    }

    abrirModalServico(content, servico) {
        this.objModal = servico;
        this.modalService.open(content, {
            ariaLabelledBy: 'modal-basic-title',
            centered: true,
            size: 'lg'
        });
    }

    fecharModal() {
        this.modalService.dismissAll();
    }
}
